export const config = {
  apiUrl: process.env.REACT_APP_API_URL,
  version: "1.0.0",
  build: "1.0",
  branch: "",
  commitHash: "",
};
